// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"da51a739f7--tooltip--sLGms","content":"da51a739f7--content--bUI_R"};